import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {environment} from "../../../environments/environment";
import Keycloak from 'keycloak-js';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private _toastr: ToastrService,
    private keycloak: Keycloak
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.keycloak.login();
        } else {
          let message = 'Error'
          if (error?.error) {
            if (error.error.message) {
              message = error.error.message
            }
            else if (error.error.details?.length > 0) {
              message = error.error.details[0]
            }
          }

          this._toastr.error(message);
        }

        return throwError(error);
      })
    )
  }
}
